module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic6.37f1d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic6.png
// module id = 485
// module chunks = 1